import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as Styled from './loading.style';

export const Loading: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Styled.Container>
      <Styled.Content>
        <img
          src="/griply-logo/griply-logo.png"
          srcSet="/griply-logo/griply-logo@2x.png 2x, /griply-logo/griply-logo@3x.png 3x"
          alt="Griply"
        />
        <Typography variant="h3">{t('pages.loading.title')}</Typography>
      </Styled.Content>

      <CircularProgress size="2.4rem" />
    </Styled.Container>
  );
};
